module.exports = __webpack_public_path__ + "images/[4]9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[4]9.jpeg
// module id = 36
// module chunks = 0